var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZunuDriveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.744141,
    width: 120.056,
    height: 120.056,
    rx: 32.7425,
    fill: "#5886FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2017_6764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5723 34.9901C22.5723 31.4885 25.4109 28.6499 28.9124 28.6499H32.0825H36.8377H49.7237C52.0587 28.6499 53.9516 30.5428 53.9516 32.8778C53.9516 35.0665 55.7259 36.8409 57.9147 36.8409H78.6157L90.4192 36.8362C95.1419 36.8343 98.9714 40.6623 98.9714 45.385V68.5202V78.9193C98.7968 85.7985 93.1668 91.4063 86.2853 91.4063H35.2593C28.2525 91.4063 22.5723 85.7262 22.5723 78.7193V34.9901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 33.4863,
    y: 32.7427,
    width: 61.3922,
    height: 45.0209,
    rx: 4.75764,
    fill: "#BED0FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2017_6764"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5723 28.6499H85.5706C92.9716 28.6499 98.9714 34.6497 98.9714 42.0507V78.0055C98.9714 85.4066 92.9716 91.4063 85.5706 91.4063H35.9731C28.572 91.4063 22.5723 85.4066 22.5723 78.0055V28.6499Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZunuDriveIcon);
export default __webpack_public_path__ + "static/media/zunu_drive_icon.89e714a9b521d44520e82c54d639678c.svg";
export { ForwardRef as ReactComponent };